import React from "react";
import { observer } from "mobx-react";
import Events from ".";

function EventPage() {
    return <Events component="page" loaderRows={10} />
}
export default observer(EventPage);
